import { Modal } from "@sunrun/experience-ui-components";
import { SLOTS_UNAVAILABLE_MESSAGE } from "./constants";
import { SlotsUnavailableModalLayout } from "./siteSurveySchedulingStyles";

type SlotsUnavailableModalProps = {
  open: boolean;
  onClose: () => void;
};

const SlotsUnavailableModal: React.FC<SlotsUnavailableModalProps> = ({
  open,
  onClose,
}) => {
  if (!open) {
    return null;
  }

  return (
    <SlotsUnavailableModalLayout>
      <Modal
        className="checkout-slots-unavailable-modal"
        testId="checkout-slots-unavailable-modal"
        hideIcon
        onClose={onClose}
        primaryButton={{
          text: "Cancel",
          onClick: onClose,
        }}
        title="Contact Team for Help"
      >
        {SLOTS_UNAVAILABLE_MESSAGE}
      </Modal>
    </SlotsUnavailableModalLayout>
  );
};

export { SlotsUnavailableModal };
